<mat-progress-bar
        [@fadeOut]="(visible) ? 'open' : 'close'"
        *ngIf="visible"
        mode="indeterminate"
        [color]="color"
        [value]="progress"
        [bufferValue]="100"
></mat-progress-bar>